@let userRole = $userRoleDetailed(); @if (userRole) {
<unity-dialog-shared title="Update Business Partner Role" (closeEvent)="onClose()">
  @let formId = 'dialogEditUserRoleFormId';
  <ng-content dialog-body>
    @let formGroup = $formGroup(); @if (formGroup) {
    <form [id]="formId" [formGroup]="formGroup" (ngSubmit)="onSave()">
      <p>
        {{ userRole.user.full_name }}'s role at {{ userRole.agency.name }} is currently:
        <br />
        <span class="bold-indent">{{ userRole.role.name }}</span>
        <br />
        To change, please select from available roles:
      </p>
      <br />
      <unity-dropdown-control
        description="Select a new role for this user"
        displayName="Role"
        [values]="$availableRoles()"
        [control]="formGroup.controls.role_id"
        (selectionChangeEvent)="onSelection($event)"
        (clearedEvent)="onClear()" />
    </form>
    }
  </ng-content>
  <ng-content ngProjectAs="[dialog-actions]">
    <button kendoButton type="button" themeColor="primary" (click)="onClose()">Cancel</button>
    @let canSubmit = $canSubmit();
    <button kendoButton themeColor="secondary" type="submit" [disabled]="canSubmit === false" [attr.form]="formId">
      @if (canSubmit === true) { Change to {{$selected().name}} } @else { (select a role) }
    </button>
  </ng-content>
</unity-dialog-shared>
}
